export const sortDashboardLanguages = (languages, sortBy, direction, locale) => {
  const nameOf = entry => entry.language?.name || '';
  const dateOf = entry => {
    const value = Date.parse(entry.added_at);
    return Number.isFinite(value) ? value : null;
  };
  return [...languages].sort((a, b) => {
    let comparison;
    if (sortBy === 'alphabetical') {
      comparison = nameOf(a).localeCompare(nameOf(b), locale, { sensitivity: 'base' });
    } else if (sortBy === 'age') {
      const aDate = dateOf(a), bDate = dateOf(b);
      // Missing dates stay last in either direction; never invent a join date.
      if (aDate === null && bDate !== null) return 1;
      if (bDate === null && aDate !== null) return -1;
      comparison = (aDate || 0) - (bDate || 0);
    } else {
      comparison = (a.average_strength || 0) - (b.average_strength || 0);
    }
    return (direction === 'asc' ? comparison : -comparison) || nameOf(a).localeCompare(nameOf(b), locale, { sensitivity: 'base' });
  });
};